<template>
  <div id="cardTemplate">
    <div class="card card-search" :style="ovarlay_div()">
      <!-- Insere Tag de rascunho caso sketch = 1 -->
      <div
        v-if="dataContent.mainImage"
        style="border-top-left-radius: 6px; border-top-right-radius: 6px"
        :style="ovarlay_div()"
      >
        <img
          :style="ovarlay_image()"
          @click.stop.prevent="editPost(dataContent.postId)"
          class="card-img-top"
          :src="CDN_URL + 'fit-in/0x350/' + dataContent.mainImage"
        />
        <div v-if="dataContent.sketch == 1" class="sketch">
          <p style="margin-top: 3px">Rascunho</p>
        </div>
      </div>
      <div v-else :style="ovarlay_div()">
        <img
          :style="ovarlay_image()"
          class="card-img-top"
          @click.stop.prevent="editPost(dataContent.postId)"
          src="@/assets/img/default-image.png"
        />
        <div v-if="dataContent.sketch == 1" class="sketch">
          <p style="margin-top: 3px">Rascunho</p>
        </div>
      </div>
      <div class="top-toolbar" v-if="dataContent.route">
        <span
          v-if="checkIfisOnlineAndHighlight(dataContent)"
          class="position-absolute text-white pointer"
          style="left: 0; padding: 0.5rem"
          @click="togglePostHighlight(dataContent)"
        >
          <i class="fa fa-star" style="margin: 12px; font-size: 22px"></i>
        </span>
        <!-- Insere Tag de Agendado caso dataAgenda() = true -->
        <div
          v-else-if="this.dataContent.scheduled == 1"
          class="publish-body"
        >
          <div class="publish">
            <img
              style="width: 23px"
              src="../assets/img/icons/ion-ios-timer.svg"
            />
            <p style="margin: 3px">Agendado {{ dataAgenda }}</p>
          </div>
        </div>
        <!-- Insere Tag star e link -->
        <!-- <div v-else> -->
        <span
          v-if="
            this.dataContent.scheduled == 0 &&
            dataContent.home_slider == false
          "
          class="position-absolute text-white pointer"
          style="left: 0; padding: 0.5rem"
          @click="togglePostHighlight"
        >
          <i class="far fa-star" style="margin: 12px; font-size: 22px"></i>
        </span>
        <a
          v-if="dataContent.route"
          :href="handleLink + dataContent.route"
          target="_blank"
          class="position-absolute text-white"
          style="right: 0; padding: 0.5rem"
        >
          <span
            class="fas fa-link"
            style="margin: 12px; font-size: 22px"
          ></span>
        </a>
        <!-- </div> -->
      </div>
      <div
        class="card-body"
        :style="backgroundColor()"
        @click.stop.prevent="editPost(dataContent.postId)"
      >
        <div class="row">
          <div class="col-12">
            <p class="molecula-data-tipo">
              <span
                class="float-left text-date opacity-50"
                v-if="dataContent.showDate && dataContent.published_at"
                >{{ normalizedDate }}</span
              >
              
            </p>
          </div>
          <div class="col-12 pt-2">
            <h5
              v-html="limitTitle(dataContent.title)"
              :title="normalizeTitle(dataContent.title)"
            ></h5>
            <p class="card-summary">{{ dataContent.summary }}</p>
          </div>
        </div>
      </div>
      <div class="card-footer" :style="backgroundColor()">
        <div style="">
          <!-- <a
						href="#"
						@click.stop.prevent="alertDelete = true"
						class="card-link delete-link float-left"
						>Excluir</a
					> -->
          <a
            href="#"
            @click.stop.prevent="alertDelete = true"
            class="card-link delete-link float-left"
            ><i class="fal fa-trash-alt font-size-17"></i
          ></a>
          <a
            href="#"
            @click.stop.prevent="alertClone = true"
            class="card-link delete-link float-left"
            ><i class="far fa-clone font-size-17"></i
          ></a>
          <a
            href="#"
            @click.stop.prevent="editPost(dataContent.postId)"
            class="card-link edit-link float-right"
            v-if="this.dataContent.sketch == 1"
            >{{ editOrUpdate }}</a
          >
        </div>
      </div>
    </div>
    <div class="card-alert text-center" v-if="alertDelete">
      <div>
        <p v-if="dataContent.home_slider == 0">
          Deseja realmente excluir este item?
        </p>
        <p v-else>
          Remover este item também irá removê-lo dos destaques da sua página
          inicial. Deseja realmente excluir?
        </p>
        <p>
          <button
            class="confirm-button"
            @click.prevent="removePost(dataContent.postId)"
          >
            Excluir
          </button>
          <button
            class="cancel-button"
            @click.stop.prevent="alertDelete = false"
          >
            Cancelar
          </button>
        </p>
      </div>
    </div>
    <div class="card-alert text-center" v-else-if="alertClone">
      <div>
        <p>Deseja clonar este item?</p>
        <p>
          <button
            class="confirm-button"
            @click.prevent="clonePost(dataContent.postId)"
          >
            <span v-if="loadingClone"
              ><i class="fal fa-spinner fa-spin"></i
            ></span>
            Clonar
          </button>
          <button
            :disabled="loadingClone"
            class="cancel-button"
            @click.stop.prevent="alertClone = false"
          >
            Cancelar
          </button>
        </p>
      </div>
    </div>
    <alertConfirmAction
      v-if="confirmActiveHighlight"
      @cancelAction="cancelAction()"
      @confirmAction="confirmAction()"
    >
      <p slot="title" class="title-alert">
        {{ confirmActionContent.title }}
      </p>
      <p slot="text" class="text-alert">
        {{ confirmActionContent.text }}
      </p>
    </alertConfirmAction>
  </div>
</template>
<script>
import gallery from "./blocks/GalleryPreview";
import imageBlock from "./blocks/ImageBlock";
import alertConfirmAction from "@/components/organisms/AlertConfirmAction";

import axios from "axios";
export default {
  name: "cardTemplate",
  data() {
    return {
      CDN_URL: null,
      ROOT_API: null,
      alertDelete: false,
      alertClone: false,
      confirmActiveHighlight: false,
      confirmActionContent: {
        title: "",
        text: "",
      },
      loadingClone: false,
    };
  },
  props: {
    dataContent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    handleLink() {
      let handle = this.$session.getAll();
      return handle.domain;
    },
    dataAgenda: function () {
      let data = this.dataContent.published_at.split("-");
      return data[2] + "/" + data[1] + "/" + data[0];
    },
    normalizedDate: function () {
      let date = JSON.stringify(this.dataContent.published_at).split(/\D/g);

      var current = "";
      var month = [
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro",
      ];

      month.forEach(function (element, index, array) {
        current = parseInt(date[2]) == index + 1 ? element : current;
      });

      return date[3] + " de " + current + " de " + date[1];
    },
    editOrUpdate: function () {
      let text = null;
      if (this.dataContent.sketch == 1) {
        text = "Publicar";
      } else {
        text = "Editar";
      }
      return text;
    },
    normalizeTextCard: function () {
      let mainText = this.dataContent.content[0].frameContent[1].frameContent;
      if (mainText) {
        if (mainText.length > 120) {
          mainText =
            this.dataContent.content[0].frameContent[1].frameContent.substring(
              0,
              120
            ) + "...";
        }
      }
      return mainText;
    },
  },
  components: {
    gallery,
    imageBlock,
    axios,
    alertConfirmAction,
  },
  methods: {
    editPost,
    removePost,
    limitTitle,
    normalizeTitle,
    togglePostHighlight,
    cancelAction,
    confirmAction,
    checkIfisOnlineAndHighlight,

    alertFalse() {
      this.alertClone = false;
      this.loadingClone = false;
    },
    clonePost(postId) {
      var vm = this;
      let siteId = this.$session.get("siteId");
      let totalData = "";
      let token = this.$session.get("jwt");
      this.loadingClone = true;
      axios({
        method: "post",
        url:
          this.ROOT_API +
          "/api/site/" +
          siteId +
          "/post/" +
          postId +
          "/duplicate",
        data: totalData,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((response) => {
          if (response.data.status == 1) {
            this.$router.push({
              name: "PostEditor",
              params: { postId: response.data.id },
            });
            vm.alertFalse();
          } else {
            alert("Erro ao duplicar post");
            vm.alertFalse();
          }
        })
        .catch(function (response) {
          alert("Erro ao duplicar post");
          console.log("Erro ao dublicar posts");
          vm.alertFalse();
        });
    },
    ovarlay_div() {
      if (
        this.dataContent.sketch == 1 ||
        this.dataContent.scheduled == 1
      ) {
        return "background-color: #FFFFFF ; !important;border-top-left-radius: 6px !important ;border-top-right-radius: 6px !important";
      }
    },
    ovarlay_image() {
      if (
        this.dataContent.sketch == 1 ||
        this.dataContent.scheduled == 1
      ) {
        return "opacity : 0.3";
      }
    },
    backgroundColor() {
      if (
        this.dataContent.sketch == 1 ||
        this.dataContent.scheduled == 1
      ) {
        return "background-color : #F4F4F4 !important";
      }
    },
  },
  created() {
    this.CDN_URL = process.env.CDN_URL;
    this.ROOT_API = process.env.ROOT_API;
  },
};
function checkIfisOnlineAndHighlight(dataCard) {
  if (dataCard.home_slider == true) {
    return true;
  } else {
    return false;
  }
}
function confirmAction() {
  let token = this.$session.get("jwt");
  axios({
    method: "post",
    url: `${this.ROOT_API}/api/site/${this.dataContent.siteId}/post/${this.dataContent.postId}/home`,
    data: "",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then((response) => {
      if (response.data.status == 1) {
        this.dataContent.home_slider = response.data.page;
      } else if (response.data.status == 0) {
        this.$emit("alertToggle");
      }
    })
    .catch(function (response) {
      console.log("Erro ao deletar posts");
    })
    .finally((response) => {
      this.confirmActiveHighlight = false;
    });
}
function cancelAction() {
  this.confirmActiveHighlight = false;
}
function togglePostHighlight() {
  if (!this.dataContent.home_slider) {
    this.confirmActionContent = {
      title: "Destacar publicação",
      text: "Deseja destacar esta publicação no carrosel da sua página inicial?",
    };
    this.confirmActiveHighlight = true;
  } else {
    this.confirmActionContent = {
      title: "Remover destaque",
      text: "Deseja remover esta publicação do carrosel da sua página inicial?",
    };
    this.confirmActiveHighlight = true;
  }
}
function normalizeTitle(title) {
  if (title) {
    let normalized = title.replace("<p>", "");
    normalized = normalized.replace("</p>", "");
    normalized = normalized.replace(/&nbsp;/g, " ");
    return normalized;
  } else {
    return null;
  }
}
function limitTitle(title) {
  if (title && title.length > 100) {
    return title.slice("0", "100") + "...";
  } else {
    return title;
  }
}
function editPost(postId) {
  this.$session.set("postId", postId);
  this.$router.push({
    name: "PostEditor",
    params: { postId: postId },
  });
}
function removePost(postId) {
  let siteId = this.$session.get("siteId");
  let totalData = "";
  let token = this.$session.get("jwt");
  axios({
    method: "post",
    url: this.ROOT_API + "/api/site/" + siteId + "/post/" + postId + "/delete",
    data: totalData,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then((response) => {
      if (response.data.status == 1) {
        this.dataContent.deleted = 1;
        this.$emit("deleteCard");
      } else {
        this.$emit("alertToggle");
      }
      this.alertDelete = false;
    })
    .catch(function (response) {
      console.log("Erro ao deletar posts");
    });
}
</script>
<style scoped>
.card {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.publish {
  width: 170px;
  height: 25px;
  background-color: #f2f2f2;
  text-align: center;
  border-radius: 50vh;
  font-size: 12px;
  margin-left: 5px;
  display: flex;
  justify-content: center;
}
.publish-body {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  top: 0;
  margin-top: 19px;
  margin-left: 14px;
}
.sketch {
  position: absolute;
  top: 0;
  margin-top: 15px;
  margin-left: 24px;
  width: 85px;
  height: 25px;
  background-color: #f2f2f2;
  text-align: center;
  border-radius: 50vh;
  font-size: 12px;
}
.card:hover {
  cursor: pointer;
}
.card-text-description {
  white-space: normal;
}
.text-date {
  font-size: 11px;
}
.card-body {
  padding: 0.75rem 1.25rem 0;
}
.loading-card {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
  color: rgb(255, 255, 255);
  font-size: 20px;
}
.top-toolbar {
  position: absolute;
  left: 0;
  right: 0;
  height: 50px;
  transition: all 3000ms;
  background-image: linear-gradient(to bottom, #22222287, #ffffff00);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.font-size-17 {
  font-size: 17px;
}
.loading-clone {
  background-image: url("../assets/loading/Uli-loading.gif") !important ;
}
</style>



// WEBPACK FOOTER //
// src/components/CardTemplate.vue